import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

export class WeightChangeModal extends Component {
  render() {
    return (
        <div>
            <Row>
                <Col sm={4}>
                    <label><Translate value="total_shipping_weight" /></label>
                </Col>
            </Row>
            <Row>
                <Col sm={4}>
                    <Input
                        type="number"
                        // value={this.props.finalShippingWeight}
                        onChange={this.props.onChange}
                    />
                </Col>
                <Col sm={6}>
                    <ButtonToolbar>
                        <Button
                            bsStyle="primary"
                            onClick={this.props.onClickButton}
                        >
                            <Translate value="save" />
                        </Button>
                    </ButtonToolbar>
                </Col>
            </Row>
        </div>
    );
  }
}

export default WeightChangeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/weightChangeModal.jsx